import React from 'react';

const SaveButton = props => {
  const { saving, buttonClasses, wrapperClasses, handleOnClick, label, buttonType, savingLabel, disabled, title } = props;
  return (
    <div className={wrapperClasses} title={disabled ? title : undefined}>
      {saving ?
        <button className={`btn btn-primary d-flex align-items-center ${buttonClasses}`} type="submit">
          <span className="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true"></span>
          <span>{savingLabel ?? 'Saving'}...</span>
        </button>
        :
        <button type={buttonType ? buttonType : 'submit'} disabled={disabled} className={`btn btn-primary ${buttonClasses}`} onClick={handleOnClick} aria-disabled="true">{label ? label : "Save"}</button>
      }
    </div>
  )
}

export default SaveButton;